import { AppWPIcon } from '../icon/AppWpIcon';

export default function AppIcon() {
    return (
        <div id='svg-container' className='hidden'>
            <AppWPIcon className='hidden' />
        </div>
    );
}
